<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ 'bikeshop.shop_setup.card_headers.flexible_rental_config' | translate }}
</span>
    </div>
  </div>


  <div>
    <div *ngIf="RentalConfigForm && !loadingConfig">
      <div class="row">
        <div class="col-md-12">
          <div class="content">
            <form [formGroup]="RentalConfigForm"
                  (ngSubmit)="saveFlexibleRentalConfig(RentalConfigForm.value)">

              <div class="row">
                <div class="col-md-12 section-header">
                  {{ 'bikeshop.rentals.configuration.rental_rules' | translate }}
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.minimum_rental_duration" | translate }}:
                </div>
                <div class="col-md-9 label">
                  <div class="radio-group">
                    <p-radioButton [value]="false" formControlName="addExtraDay"
                                   label="{{ 'bikeshop.rentals.configuration.24_hours_equals_1_day' | translate }}"></p-radioButton>
                    <p-radioButton [value]="true" formControlName="addExtraDay"
                                   label="{{ 'bikeshop.rentals.configuration.each_day_past_midnight_new_day' | translate }}"></p-radioButton>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                </div>
                <div class="col-md-9 label">
                  <ul>
                    <li>{{ 'bikeshop.rentals.configuration.24_hours_equals_1_day_info' | translate }}</li>
                    <li>{{ 'bikeshop.rentals.configuration.each_day_past_midnight_new_day_info' | translate }}</li>
                  </ul>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['minimumDurationValue'].invalid}">
                  {{ "bikeshop.rentals.configuration.minimum_rental_duration" | translate }}:
                </div>
                <div class="col-md-1 label">
                  <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="minimumDurationValue"/>
                  </div>
                </div>
                <div class="col-md-2 label">
                  <p-dropdown [options]="timeUnits"
                              formControlName="minimumDurationUnitType"></p-dropdown>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-3 label"
                     [ngClass]="{'red': RentalConfigForm.controls['maximumDurationValue'].invalid}">
                  {{ "bikeshop.rentals.configuration.maximum_rental_duration" | translate }}:
                </div>
                <div class="col-md-1 label">
                  <div class="p-inputgroup">
                    <input type="number" pInputText formControlName="maximumDurationValue"/>
                  </div>
                </div>
                <div class="col-md-2 label">
                  <p-dropdown [options]="timeUnits"
                              formControlName="maximumDurationUnitType"></p-dropdown>
                </div>
              </div>

              <div class="row margin-top-16"
                   *ngIf="(RentalConfigForm.value.minimumDurationValue && RentalConfigForm.value.minimumDurationUnitType && RentalConfigForm.value.maximumDurationValue && RentalConfigForm.value.maximumDurationUnitType)">
                <div class="col-md-3 label">
                </div>
                <div class="col-md-9 label">
                  {{ 'bikeshop.rentals.configuration.flexible_duration_confirmation' | translate : {
                  minVal:
                  RentalConfigForm.value.minimumDurationValue, minUnit:
                    getUnitValue(RentalConfigForm.value.minimumDurationUnitType), maxVal:
                  RentalConfigForm.value.maximumDurationValue, maxUnit:
                    getUnitValue(RentalConfigForm.value.maximumDurationUnitType)
                } }}
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-9"></div>
                <div class="col-md-3">
                  <button type="submit" class="iso-round-button full-width"
                          [disabled]="!RentalConfigForm.valid || busy || !(RentalConfigForm.value.minimumDurationValue >= 0 && RentalConfigForm.value.minimumDurationUnitType && RentalConfigForm.value.maximumDurationValue && RentalConfigForm.value.maximumDurationUnitType)">{{
                    'bikeshop.rentals.configuration.update_configuration' | translate
                    }}</button>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="content" *ngIf="!loadingConfig">
    <div class="content-header">
      <div>
        <div class="category-header">{{ 'bikeshop.rentals.pricing.flexible_time_units' | translate }}</div>
        <div class="category-description">{{ 'bikeshop.rentals.pricing.flexible_time_units_description' | translate :
          {
            minVal: RentalConfigForm.value.minimumDurationValue, minUnit:
              getUnitValue(RentalConfigForm.value.minimumDurationUnitType), maxVal:
            RentalConfigForm.value.maximumDurationValue, maxUnit:
              getUnitValue(RentalConfigForm.value.maximumDurationUnitType)
          } }}
        </div>
      </div>
      <div class="pull-right">
        <div class="margin-top-16" style="margin-bottom: -36px;">
          <button pButton (click)="addTimeUnit()" class="p-button-raised alternate"
                  label="{{'bikeshop.rentals.pricing.add_flexible_time_unit' | translate}}"
                  style="width: 200px;"></button>
        </div>
      </div>
    </div>
    <div *ngIf="loadingFlexibleTimeUnits" style="margin-top: 16px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="time-unit-container margin-top-16">
      <div *ngFor="let timeUnit of flexibleTimeUnits" class="time-unit-item">
        <div class="time-unit-title" (click)="editTimeUnit(timeUnit)"
             *ngIf="!(timeUnit.fromUnit === timeUnit.toUnit && timeUnit.fromUnitType === timeUnit.toUnitType)">
          {{timeUnit.fromUnit}} {{timeUnit.fromUnitType}}{{timeUnit.fromUnit > 1 ? 's' : ''}}
          - {{timeUnit.toUnit}}
          {{timeUnit.toUnitType}}{{timeUnit.toUnit > 1 ? 's' : ''}}</div>
        <div class="time-unit-title" (click)="editTimeUnit(timeUnit)"
             *ngIf="(timeUnit.fromUnit === timeUnit.toUnit && timeUnit.fromUnitType === timeUnit.toUnitType)">
          {{timeUnit.fromUnit}} {{timeUnit.fromUnitType}}{{timeUnit.fromUnit > 1 ? 's' : ''}}</div>
      </div>
      <div class="no-data" *ngIf="!loadingFlexibleTimeUnits && flexibleTimeUnits.length === 0">{{
        'bikeshop.rentals.pricing.no_bookable_time_units' | translate }}</div>
    </div>
    <div *ngIf="findRuleGaps().length > 0" class="rules-missing">
      <div>{{ 'bikeshop.rentals.pricing.time_unit_error' | translate }}</div>
      <ul>
        <li *ngFor="let range of findRuleGaps()">{{range.rangeStartUnit}} {{getUnitValue(range.rangeStartUnitType)}}
          - {{range.rangeEndUnit}} {{getUnitValue(range.rangeEndUnitType)}}</li>
      </ul>
    </div>
  </div>


  <div class="content margin-top-16" *ngIf="!loadingConfig">
    <div class="content-header">
      <div>
        <div class="category-header">{{ 'bikeshop.rentals.pricing.pricing_configuration' | translate }}</div>
        <div
          class="category-description">{{ 'bikeshop.rentals.pricing.flexible_pricing_configuration_description' | translate }}
        </div>
      </div>
      <div class="pull-right">
        <div class="margin-top-16" style="margin-bottom: -36px;">
          <button pButton (click)="addPriceGroup()" class="p-button-raised alternate"
                  [disabled]="!(RentalConfigForm.value.minimumDurationValue >= 0 && RentalConfigForm.value.minimumDurationUnitType && RentalConfigForm.value.maximumDurationValue && RentalConfigForm.value.maximumDurationUnitType)"
                  label="{{'bikeshop.rentals.pricing.add_price_group' | translate}}"
                  style="width: 200px;"></button>
        </div>
      </div>
    </div>
    <div *ngIf="loadingPriceGroupsDetail" style="margin-top: 16px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div class="price-group-container margin-top-16" *ngIf="priceGroupsDetail">
      <div *ngFor="let priceGroup of priceGroupsDetail" class="price-group-item"
           (click)="updatePriceGroup(priceGroup)">
        <div class="price-group-title">{{priceGroup.name}}</div>
        <!-- <div class="price-group-description">{{priceGroup.description}}</div> -->
        <div class="margin-top-16">
          <div *ngFor="let timeUnit of priceGroup.flexibleRentalRate" class="price-group-time-unit"
               [ngClass]="{'red': !timeUnit.internalProductID && !timeUnit.rate}">
            <div><span class="fa"
                       [ngClass]="{'fa-exclamation-triangle': !timeUnit.internalProductID && !timeUnit.rate, 'fa-check': timeUnit.internalProductID || timeUnit.rate}"></span>
              {{timeUnit.fromUnit}} {{timeUnit.fromUnitType}}{{timeUnit.fromUnit > 1 ? 's' : ''}}
              - {{timeUnit.toUnit}}
              {{timeUnit.toUnitType}}{{timeUnit.toUnit > 1 ? 's' : ''}}
            </div>
            <div *ngIf="timeUnit.rate || timeUnit.internalProductID">
              <div>{{timeUnit.rate | currency : timeUnit.currencySymbol}} {{ 'bikeshop.rentals.pricing.per_day' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data"
           *ngIf="!loadingPriceGroupsDetail && priceGroupsDetail && priceGroupsDetail.length === 0">{{
        'bikeshop.rentals.pricing.no_price_groups' | translate }}</div>
    </div>
  </div>
</div>


<p-sidebar #NavSideBar [(visible)]="showPriceGroup" position="right" [autoZIndex]="true" [baseZIndex]="0"
           [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="getRentalPriceGroupsDetail(); NavSideBar.destroyModal()">
  <div *ngIf="showPriceGroup">
    <app-add-edit-flexible-price-group (close)="closePriceGroup()"
                                       [priceGroup]="selectedPriceGroup"></app-add-edit-flexible-price-group>
  </div>
</p-sidebar>


<p-dialog *ngIf="showTimeUnitDialog" [(visible)]="showTimeUnitDialog" [modal]="true" [contentStyle]="{'width':'400px'}">
  <p-header>
    {{ selectedTimeUnit.id ? ('bikeshop.rentals.pricing.edit_time_unit' | translate) :
    ('bikeshop.rentals.pricing.edit_flexible_time_unit' | translate) }}
  </p-header>
  <div style="padding-bottom: 50px;">
    <div class="row margin-top-8">
      <div class="col-md-4 label"
           [ngClass]="{'red bold': selectedTimeUnit.fromUnit === undefined || selectedTimeUnit.fromUnit === null || selectedTimeUnit.fromUnit.length === 0 || checkFromUnitUsed()}">
        {{ 'bikeshop.rentals.pricing.from_unit_value' | translate }}:
      </div>
      <div class="col-md-4 value">
        <input type="number" pInputText [(ngModel)]="selectedTimeUnit.fromUnit"/>
      </div>
      <div class="col-md-4 value">
        <div>
          <p-dropdown [options]="timeUnits" [(ngModel)]="selectedTimeUnit.fromUnitTypeID"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-4 label"
           [ngClass]="{'red bold': selectedTimeUnit.toUnit === undefined || selectedTimeUnit.toUnit === null || selectedTimeUnit.toUnit.length === 0 || checkToUnitUsed()}">
        {{ 'bikeshop.rentals.pricing.to_unit_value' | translate }}:
      </div>
      <div class="col-md-4 value">
        <input type="number" pInputText [(ngModel)]="selectedTimeUnit.toUnit"/>
      </div>
      <div class="col-md-4 value">
        <div>
          <p-dropdown [options]="timeUnits" [(ngModel)]="selectedTimeUnit.toUnitTypeID"></p-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 margin-top-16 red">
        <ul style="padding-left: 16px;">
          <li
            *ngIf="(selectedTimeUnit.toUnitTypeID === selectedTimeUnit.fromUnitTypeID && selectedTimeUnit.toUnit < selectedTimeUnit.fromUnit) || selectedTimeUnit.toUnitTypeID < selectedTimeUnit.fromUnitTypeID">{{ 'bikeshop.rentals.pricing.error_1' | translate }}</li>
          <li *ngIf="checkFromUnitUsed()">{{ 'bikeshop.rentals.pricing.error_2' | translate }}</li>
          <li *ngIf="checkToUnitUsed()">{{ 'bikeshop.rentals.pricing.error_3' | translate }}</li>
        </ul>
      </div>
    </div>


  </div>
  <p-footer>
    <div class="margin-top-16 button-container">
      <div style="display: flex; justify-content: space-between;">
        <div style="display: flex;">
          <div *ngIf="selectedTimeUnit.id" style="margin-right: 20px;">
            <button pButton *ngIf="!removingTimeUnit"
                    label="{{ 'bikeshop.rentals.pricing.remove_time_unit' | translate}}"
                    class="p-button-raised alternate"
                    (click)="removeFlexibleTimeUnit()" [disabled]="savingTimeUnit"></button>
            <div *ngIf="removingTimeUnit">
              <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
              </p-progressSpinner>
            </div>
          </div>
        </div>
        <button *ngIf="!savingTimeUnit" pButton (click)="saveFlexibleTimeUnit()" class="p-button-raised"
                label="{{'bikeshop.general.save' | translate}}"
                [disabled]="!isSelectedTimeUnitValid() || removingTimeUnit"></button>
        <div *ngIf="savingTimeUnit">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                             animationDuration=".5s"></p-progressSpinner>
        </div>
      </div>
    </div>
  </p-footer>
</p-dialog>
